var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {}; // Functions placed here will be ran at different points in the boot sequence
OCS.BootFunctions.application = OCS.BootFunctions.application || {};
OCS.BootFunctions.application.init_ui = function () {
    var user_ops = {};
    if (OCS.User_data) {
        user_ops = OCS.User_data;
    }
    OCS.User = new OCS.Classes.OkfirstUser(user_ops);
    var ui = OCS.WxBriefing.Functions.get_ui();
    OCS.WxBriefing.Live.Controller.fireEvent('ui_ready');

    if (OCS.fixed_reference_time && OCS.reference_time) {
        // We have a fixed reference time to consider
        ui.set_actively_retrieve_data(false);
    }
};